/* eslint-disable import/no-anonymous-default-export */
import { SET_FILE_TEXT } from '../actionConstants';

export default (state = '', action) => {
  switch (action.type) {
    case SET_FILE_TEXT:
      return action.payload;
    default:
      return state;
  }
};
